/* eslint-disable */
import React, { useState, useEffect } from "react";
import saveStoreDraft from "../../utils/saveStoreDraft";
import useStoreFormDraft from "../../hooks/useStoreFormDraft";
import { useSelector } from "react-redux";
import Sidebar from "../../components/sidebar/Sidebar2";
import Navbar from "../../components/navbar/Navbar2";
import Footer from "../../components/footer/Footer";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { doc } from "firebase/firestore";
import { db } from "../../firebase";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import apicache from "../../components/clearCach/clear";
import { Switch, InputNumber, Select } from "antd";
import { useTranslation } from "react-i18next";
import { ArrowUpDown, ChevronRight, ShoppingCart } from "lucide-react";

import {
  FormInput,
  Type,
  UserRound,
  Phone,
  MessageSquare,
  Save,
  Info,
  Mail,
} from "lucide-react";
import FormPreview from "./FormPreviewDigital";

function DigitalForm() {
  const digitalStore = useSelector((state) => state.digitalStoreReducer);
  const account = useSelector((state) => state.AccountReducer);
  const products = useSelector((state) => state.ProductsReducer);
  const [showSideBar, setShowSideBar] = useState(true);
  const [data, setData] = useStoreFormDraft(digitalStore);
  const [loading, setLoading] = useState(false);
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir() === "rtl";
  useEffect(() => {
    function handleResize() {
      if (window.innerWidth <= 1080) {
        setShowSideBar(false);
      } else {
        setShowSideBar(true);
      }
    }

    window.addEventListener("resize", handleResize);
    handleResize();
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleCardClick = (product) => {
    switch (data.productClickBehavior) {
      case "newPage":
        window.open(`/product/${product.id}`, "_blank");
        break;
      case "modal":
        openProductModal(product);
        break;
      case "mixed1":
        window.open(`/product/${product.id}`, "_blank");
        break;
      case "mixed2":
        openProductModal(product);
        break;
    }
  };

  const handleBuyButtonClick = (product, e) => {
    e.stopPropagation();

    switch (data.productClickBehavior) {
      case "newPage":
        window.open(`/product/${product.id}`, "_blank");
        break;
      case "modal":
        openProductModal(product);
        break;
      case "mixed1":
        openProductModal(product);
        break;
      case "mixed2":
        window.open(`/product/${product.id}`, "_blank");
        break;
    }
  };
  const message = (e) => {
    e.preventDefault();
    const MySwal = withReactContent(Swal);
    MySwal.fire({
      title: (
        <a href="https://m.me/F0orweb" target="_blank">
          {t("footerSettings.swal_contact_link")}
        </a>
      ),
      isDismissed: true,
      confirmButtonColor: "#9b59bf",
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    apicache(account, products);

    try {
      await saveStoreDraft(doc(db, "digitalStore", data.id), digitalStore, data);
      Swal.fire({
        icon: "success",
        title: t("digitalForm.submitFeedback.success.title"),
        confirmButtonText: t("digitalForm.submitFeedback.success.button"),
        confirmButtonColor: "#9b59bf",
      });
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: t("digitalForm.submitFeedback.error.title"),
        text: t("digitalForm.submitFeedback.error.message"),
        confirmButtonText: t("digitalForm.submitFeedback.error.button"),
        confirmButtonColor: "#9b59bf",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleDChange7 = () =>
    setData({ ...data, digitalNameRequired: !data.digitalNameRequired });
  const handleDChange5 = () =>
    setData({ ...data, digitalNameField: !data.digitalNameField });
  const handleDChange6 = () => setData({ ...data, num: !data.num });
  const handleDChange8 = () => setData({ ...data, numR: !data.numR });
  const handleEmailFieldChange = () =>
    setData({
      ...data,
      digitalEmailField: !data.digitalEmailField,
    });

  const handleEmailRequiredChange = (value) =>
    setData({
      ...data,
      digitalEmailRequired: value,
    });

  const handlePrivacyToggle = () => {
    setData({ ...data, privacyPolicyField: !data.privacyPolicyField });
  };
  const handlePrivacyRequiredToggle = () => {
    setData({ ...data, privacyPolicyRequired: !data.privacyPolicyRequired });
  };
  return (
    <div
      className="container-fluid bg-purple-50 dark:!bg-[#141414] min-h-screen"
      dir={isRTL ? "rtl" : "ltr"}
    >
      <div className="row">
        {showSideBar && (
          <div
            style={{
              width: "250px",
              flexShrink: 0,
              transition: "width 0.6s ease",
              boxShadow: "2px 0 10px rgba(0,0,0,0.05)",
            }}
          >
            <Sidebar
              showSideBar={showSideBar}
              setShowSideBar={setShowSideBar}
            />
          </div>
        )}
        <div
          className="px-3 dark:!bg-[#141414]"
          style={{ flex: 1, backgroundColor: "#fbf8fc" }}
        >
          <Navbar showSideBar={showSideBar} setShowSideBar={setShowSideBar} />

          {/* Page Header */}
          <div className="bg-white dark:!bg-[#181819] rounded-xl shadow-sm p-4 m-3 mt-6 border border-[#fbf4ff] dark:!border-[#3c3a3d]">
            <div className="flex flex-wrap items-center justify-between gap-3">
              <div>
                <h2 className="text-xl font-bold text-[#9e68ba] mb-1">
                  {t("digitalForm.header.title")}
                </h2>
                <p className="text-gray-600 dark:!text-gray-400 mb-0">
                  {t("digitalForm.header.subtitle")}
                </p>
              </div>
              <button
                onClick={!!account.store ? handleSubmit : message}
                className={`flex items-center gap-2 bg-[#9b59bf] hover:bg-[#814a9f] text-white py-2 px-4 rounded-lg transition-colors ${
                  loading ? "opacity-75 cursor-wait" : ""
                }`}
                disabled={loading}
              >
                <Save size={18} />
                <span className="mr-1">
                  {loading
                    ? t("digitalForm.header.saveButton.loading")
                    : t("digitalForm.header.saveButton.default")}
                </span>
              </button>
            </div>
          </div>

          {/* Main Content */}
          <div className="mx-3 mb-6">
            {data && (
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                {/* Form Settings Column */}
                <div className="md:col-span-2">
                  {/* Form Header Section */}
                  <div className="bg-white dark:!bg-[#181819] rounded-xl shadow-sm p-6 border border-[#fbf4ff] dark:!border-[#3c3a3d] mb-6">
                    <div className="flex items-center mb-4">
                      <FormInput size={20} className="text-[#9e68ba] ml-2" />
                      <h3 className="text-lg font-semibold text-gray-800 dark:!text-gray-200">
                        {t("digitalForm.formHeaderSection.title")}
                      </h3>
                    </div>

                    <div className="mb-4">
                      <label className="block text-sm font-medium text-[#9e68ba] mb-2">
                        {t(
                          "digitalForm.formHeaderSection.fields.headerMessage.label"
                        )}
                      </label>
                      <input
                        value={data.digitalHeaderForm || ""}
                        onChange={(e) =>
                          setData({
                            ...data,
                            digitalHeaderForm: e.target.value,
                          })
                        }
                        type="text"
                        placeholder={t(
                          "digitalForm.formHeaderSection.fields.headerMessage.placeholder"
                        )}
                        className="w-full px-3 py-2 border border-gray-300 dark:!border-[#3c3a3d] rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-200 dark:bg-[#141414] dark:text-gray-300"
                      />
                    </div>

                    <div className="mb-4">
                      <label className="block text-sm font-medium text-[#9e68ba] mb-2">
                        {t(
                          "digitalForm.formHeaderSection.fields.buttonText.label"
                        )}
                      </label>
                      <input
                        value={data.digitalNameButton || ""}
                        onChange={(e) =>
                          setData({
                            ...data,
                            digitalNameButton: e.target.value,
                          })
                        }
                        type="text"
                        placeholder={t(
                          "digitalForm.formHeaderSection.fields.buttonText.placeholder"
                        )}
                        className="w-full px-3 py-2 border border-gray-300 dark:!border-[#3c3a3d] rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-200 dark:bg-[#141414] dark:text-gray-300"
                      />
                    </div>
                  </div>

                  <div className="bg-white dark:!bg-[#181819] rounded-xl shadow-sm p-6 border border-[#fbf4ff] dark:!border-[#3c3a3d] mb-6">
                    <div className="flex items-center mb-4">
                      <ArrowUpDown size={20} className="text-[#9e68ba] ml-2" />
                      <h3 className="text-lg font-semibold text-gray-800 dark:!text-gray-200">
                        {t("digitalForm.formStepsSection.title")}
                      </h3>
                    </div>

                    <div className="mb-4">
                      <label className="block text-sm font-medium text-[#9e68ba] mb-3">
                        {t(
                          "digitalForm.formStepsSection.fields.stepsOrder.label"
                        )}
                      </label>

                      <div className="space-y-3">
                        {/* Option 1: Info → Offers → Payment */}
                        <div
                          className={`relative p-4 border-2 rounded-lg cursor-pointer transition-all duration-200 ${
                            JSON.stringify(data.formStepsOrder) ===
                            JSON.stringify(["info", "offer", "payment"])
                              ? "border-[#9e68ba] bg-purple-50 dark:bg-purple-900/20"
                              : "border-gray-300 dark:!border-[#3c3a3d] hover:border-[#9e68ba]/50"
                          }`}
                          onClick={() =>
                            setData({
                              ...data,
                              formStepsOrder: ["info", "offer", "payment"],
                            })
                          }
                        >
                          <div className="flex items-center">
                            <div
                              className={`w-4 h-4 rounded-full border-2 mr-3 flex items-center justify-center ${
                                JSON.stringify(data.formStepsOrder) ===
                                JSON.stringify(["info", "offer", "payment"])
                                  ? "border-[#9e68ba] bg-[#9e68ba]"
                                  : "border-gray-300 dark:border-[#3c3a3d]"
                              }`}
                            >
                              {JSON.stringify(data.formStepsOrder) ===
                                JSON.stringify([
                                  "info",
                                  "offer",
                                  "payment",
                                ]) && (
                                <div className="w-2 h-2 rounded-full bg-white"></div>
                              )}
                            </div>
                            <div className="flex-1">
                              <div className="font-medium text-gray-800 dark:text-gray-200 mb-1">
                                {t(
                                  "digitalForm.formStepsSection.options.infoFirst.title"
                                )}
                              </div>
                              <div className="flex items-center space-x-2 text-sm text-gray-600 dark:text-gray-400">
                                <span className="px-2 py-1 bg-blue-100 dark:bg-blue-900/30 text-blue-700 dark:text-blue-300 rounded">
                                  1.{" "}
                                  {t("digitalForm.formStepsSection.steps.info")}
                                </span>
                                <ChevronRight size={14} />
                                <span className="px-2 py-1 bg-green-100 dark:bg-green-900/30 text-green-700 dark:text-green-300 rounded">
                                  2.{" "}
                                  {t(
                                    "digitalForm.formStepsSection.steps.offers"
                                  )}
                                </span>
                                <ChevronRight size={14} />
                                <span className="px-2 py-1 bg-purple-100 dark:bg-purple-900/30 text-purple-700 dark:text-purple-300 rounded">
                                  3.{" "}
                                  {t(
                                    "digitalForm.formStepsSection.steps.payment"
                                  )}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* Option 2: Offers → Info → Payment */}
                        <div
                          className={`relative p-4 border-2 rounded-lg cursor-pointer transition-all duration-200 ${
                            JSON.stringify(data.formStepsOrder) ===
                            JSON.stringify(["offer", "info", "payment"])
                              ? "border-[#9e68ba] bg-purple-50 dark:bg-purple-900/20"
                              : "border-gray-300 dark:!border-[#3c3a3d] hover:border-[#9e68ba]/50"
                          }`}
                          onClick={() =>
                            setData({
                              ...data,
                              formStepsOrder: ["offer", "info", "payment"],
                            })
                          }
                        >
                          <div className="flex items-center">
                            <div
                              className={`w-4 h-4 rounded-full border-2 mr-3 flex items-center justify-center ${
                                JSON.stringify(data.formStepsOrder) ===
                                JSON.stringify(["offer", "info", "payment"])
                                  ? "border-[#9e68ba] bg-[#9e68ba]"
                                  : "border-gray-300 dark:border-[#3c3a3d]"
                              }`}
                            >
                              {JSON.stringify(data.formStepsOrder) ===
                                JSON.stringify([
                                  "offer",
                                  "info",
                                  "payment",
                                ]) && (
                                <div className="w-2 h-2 rounded-full bg-white"></div>
                              )}
                            </div>
                            <div className="flex-1">
                              <div className="font-medium text-gray-800 dark:text-gray-200 mb-1">
                                {t(
                                  "digitalForm.formStepsSection.options.offersFirst.title"
                                )}
                              </div>
                              <div className="flex items-center space-x-2 text-sm text-gray-600 dark:text-gray-400">
                                <span className="px-2 py-1 bg-green-100 dark:bg-green-900/30 text-green-700 dark:text-green-300 rounded">
                                  1.{" "}
                                  {t(
                                    "digitalForm.formStepsSection.steps.offers"
                                  )}
                                </span>
                                <ChevronRight size={14} />
                                <span className="px-2 py-1 bg-blue-100 dark:bg-blue-900/30 text-blue-700 dark:text-blue-300 rounded">
                                  2.{" "}
                                  {t("digitalForm.formStepsSection.steps.info")}
                                </span>
                                <ChevronRight size={14} />
                                <span className="px-2 py-1 bg-purple-100 dark:bg-purple-900/30 text-purple-700 dark:text-purple-300 rounded">
                                  3.{" "}
                                  {t(
                                    "digitalForm.formStepsSection.steps.payment"
                                  )}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <p className="text-xs text-gray-500 dark:text-gray-400 mt-2">
                        {t(
                          "digitalForm.formStepsSection.fields.stepsOrder.description"
                        )}
                      </p>
                    </div>
                  </div>

                  <div className="bg-white dark:!bg-[#181819] rounded-xl shadow-sm p-6 border border-[#fbf4ff] dark:!border-[#3c3a3d] mb-6">
                    <div className="flex items-center mb-4">
                      <UserRound size={20} className="text-[#9e68ba] ml-2" />
                      <h3 className="text-lg font-semibold text-gray-800 dark:text-gray-200">
                        {t("digitalForm.customerInfoSection.title")}
                      </h3>
                    </div>

                    {/* Name Field */}
                    <div className="border border-gray-200 dark:!border-[#3c3a3d] rounded-lg p-4 mb-4">
                      <div className="flex items-center justify-between mb-3">
                        <div className="flex items-center gap-x-2">
                          <input
                            type="checkbox"
                            checked={data.digitalNameField != false}
                            onChange={handleDChange5}
                            className="h-4 w-4 text-purple-600 rounded border-gray-300 dark:!border-[#3c3a3d] focus:ring-purple-200"
                          />
                          <label className="ml-2 block text-sm font-medium text-gray-700 dark:text-gray-300">
                            {t(
                              "digitalForm.customerInfoSection.nameField.label"
                            )}
                          </label>
                        </div>
                        <OverlayTrigger
                          placement="top"
                          overlay={
                            <Tooltip>
                              {t(
                                "digitalForm.customerInfoSection.nameField.tooltip"
                              )}
                            </Tooltip>
                          }
                        >
                          <span>
                            <Info
                              size={16}
                              className="text-gray-400 dark:text-gray-500"
                            />
                          </span>
                        </OverlayTrigger>
                      </div>

                      <div className="mb-3">
                        <input
                          type="text"
                          placeholder={t(
                            "digitalForm.customerInfoSection.nameField.placeholder"
                          )}
                          className="w-full px-3 py-2 border border-gray-300 dark:!border-[#3c3a3d] rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-200 dark:bg-[#141414] dark:text-gray-300"
                          value={data.digitalNamePlaceholder || ""}
                          onChange={(e) =>
                            setData({
                              ...data,
                              digitalNamePlaceholder: e.target.value,
                            })
                          }
                          disabled={!data.digitalNameField}
                        />
                      </div>

                      <div className="flex items-center gap-2 mb-3">
                        <Switch
                          size="small"
                          checked={data.digitalNameRequired}
                          onChange={handleDChange7}
                          disabled={!data.digitalNameField}
                          className="bg-gray-300 dark:bg-[#3c3a3d]"
                        />
                        <span className="text-sm text-gray-600 dark:text-gray-400">
                          {t(
                            "digitalForm.customerInfoSection.nameField.required"
                          )}
                        </span>
                      </div>
                    </div>

                    {/* Phone Field */}
                    <div className="border border-gray-200 dark:!border-[#3c3a3d] rounded-lg p-4 mb-4">
                      <div className="flex items-center justify-between mb-3">
                        <div className="flex items-center gap-x-2">
                          <input
                            type="checkbox"
                            checked={data.num}
                            onChange={(e) => {
                              if (data.num) return;
                              handleDChange6(e);
                            }}
                            className="h-4 w-4 text-purple-600 rounded border-gray-300 dark:!border-[#3c3a3d] focus:ring-purple-200"
                            disabled={data.num}
                          />
                          <label className="ml-2 block text-sm font-medium text-gray-700 dark:text-gray-300">
                            {t(
                              "digitalForm.customerInfoSection.phoneField.label"
                            )}
                          </label>
                        </div>
                        <OverlayTrigger
                          placement="top"
                          overlay={
                            <Tooltip>
                              {t(
                                "digitalForm.customerInfoSection.phoneField.tooltip"
                              )}
                            </Tooltip>
                          }
                        >
                          <span>
                            <Phone
                              size={16}
                              className="text-gray-400 dark:text-gray-500"
                            />
                          </span>
                        </OverlayTrigger>
                      </div>

                      <div className="mb-3">
                        <input
                          type="text"
                          placeholder={t(
                            "digitalForm.customerInfoSection.phoneField.placeholder"
                          )}
                          className="w-full px-3 py-2 border border-gray-300 dark:!border-[#3c3a3d] rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-200 dark:bg-[#141414] dark:text-gray-300"
                          value={data.digitalPhoneNumberPlaceHolder || ""}
                          onChange={(e) =>
                            setData({
                              ...data,
                              digitalPhoneNumberPlaceHolder: e.target.value,
                            })
                          }
                        />
                      </div>

                      <div className="flex items-center gap-2 mb-3">
                        <Switch
                          size="small"
                          checked={data.numR}
                          onChange={handleDChange8}
                          className="bg-gray-300 dark:bg-[#3c3a3d]"
                          disabled={true}
                        />
                        <span className="text-sm text-gray-600 dark:text-gray-400">
                          {t(
                            "digitalForm.customerInfoSection.phoneField.required"
                          )}
                        </span>
                      </div>

                      <div className="flex flex-wrap items-center gap-2">
                        <span className="text-sm text-gray-600 dark:text-gray-400">
                          {t(
                            "digitalForm.customerInfoSection.phoneField.minDigits"
                          )}
                        </span>
                        <div className="dark:bg-[#181819] dark:!border-[#3c3a3d] dark:!text-white border  rounded-md">
                          <InputNumber
                            size="small"
                            dir="ltr"
                            style={{ width: "60px" }}
                            value={data.numberPhone}
                            onChange={(value) =>
                              setData({
                                ...data,
                                numberPhone: value,
                              })
                            }
                            min={0}
                            max={20}
                            className="!bg-transparent !border-none dark:text-white"
                          />
                        </div>
                        <span className="text-sm text-gray-600 ml-2 dark:text-gray-400">
                          {t(
                            "digitalForm.customerInfoSection.phoneField.maxDigits"
                          )}
                        </span>
                        <div className="dark:bg-[#181819] dark:!border-[#3c3a3d] dark:!text-white border  rounded-md">
                          <InputNumber
                            size="small"
                            dir="ltr"
                            style={{ width: "60px" }}
                            value={data.numberPhonemax}
                            onChange={(value) =>
                              setData({
                                ...data,
                                numberPhonemax: value,
                              })
                            }
                            min={0}
                            max={20}
                            className="!bg-transparent !border-none dark:text-white"
                          />
                        </div>
                      </div>
                    </div>

                    {/* Email Field */}
                    <div className="border border-gray-200 dark:!border-[#3c3a3d] rounded-lg p-4">
                      <div className="flex items-center justify-between mb-3">
                        <div className="flex items-center gap-x-2">
                          <input
                            type="checkbox"
                            checked={data.digitalEmailField || false}
                            onChange={handleEmailFieldChange}
                            className="h-4 w-4 text-purple-600 rounded border-gray-300 dark:!border-[#3c3a3d] focus:ring-purple-200"
                          />
                          <label className="ml-2 block text-sm font-medium text-gray-700 dark:text-gray-300">
                            {t(
                              "digitalForm.customerInfoSection.emailField.label"
                            )}
                          </label>
                        </div>
                        <OverlayTrigger
                          placement="top"
                          overlay={
                            <Tooltip>
                              {t(
                                "digitalForm.customerInfoSection.emailField.tooltip"
                              )}
                            </Tooltip>
                          }
                        >
                          <span>
                            <Mail
                              size={16}
                              className="text-gray-400 dark:text-gray-500"
                            />
                          </span>
                        </OverlayTrigger>
                      </div>

                      <div className="mb-3">
                        <input
                          type="text"
                          placeholder={t(
                            "digitalForm.customerInfoSection.emailField.placeholder"
                          )}
                          className="w-full px-3 py-2 border border-gray-300 dark:!border-[#3c3a3d] rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-200 dark:bg-[#141414] dark:text-gray-300"
                          value={data.digitalEmailPlaceholder || ""}
                          onChange={(e) =>
                            setData({
                              ...data,
                              digitalEmailPlaceholder: e.target.value,
                            })
                          }
                          disabled={!data.digitalEmailField}
                        />
                      </div>

                      <div className="flex items-center gap-2">
                        <span className="text-sm text-gray-600 ml-2 dark:text-gray-400">
                          {t(
                            "digitalForm.customerInfoSection.emailField.typeLabel"
                          )}
                        </span>

                        <div className="dark:bg-[#181819] dark:border-[#3c3a3d] border rounded-md w-[200px]">
                          <Select
                            size="small"
                            value={data.digitalEmailRequired || "optional"}
                            onChange={handleEmailRequiredChange}
                            disabled={!data.digitalEmailField}
                            className="!bg-transparent !border-none dark:text-gray-300"
                            style={{ width: "100%" }}
                          >
                            <Option value="optional">
                              {t(
                                "digitalForm.customerInfoSection.emailField.options.optional"
                              )}
                            </Option>
                            <Option value="required">
                              {t(
                                "digitalForm.customerInfoSection.emailField.options.required"
                              )}
                            </Option>
                            <Option value="required_if_no_whatsapp">
                              {t(
                                "digitalForm.customerInfoSection.emailField.options.required_if_no_whatsapp"
                              )}
                            </Option>
                          </Select>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Note Field */}
                  <div className="bg-white dark:!bg-[#181819] rounded-xl shadow-sm p-6 border border-[#fbf4ff] dark:!border-[#3c3a3d] mb-6">
                    <div className="flex items-center mb-4">
                      <MessageSquare
                        size={20}
                        className="text-[#9e68ba] ml-2"
                      />
                      <h3 className="text-lg font-semibold text-gray-800 dark:text-gray-200">
                        {t("digitalForm.noteSection.title")}
                      </h3>
                    </div>

                    <div className="border border-gray-200 dark:!border-[#3c3a3d] rounded-lg p-4">
                      <div className="flex items-center justify-between mb-3">
                        <div className="flex items-center gap-x-2">
                          <input
                            type="checkbox"
                            checked={true}
                            className="h-4 w-4 text-purple-600 rounded border-gray-300 dark:!border-[#3c3a3d] focus:ring-purple-200"
                            disabled={true}
                          />
                          <label className="ml-2 block text-sm font-medium text-gray-700 dark:text-gray-300">
                            {t("digitalForm.noteSection.label")}
                          </label>
                        </div>
                      </div>

                      <div className="mb-3">
                        <input
                          type="text"
                          placeholder={t("digitalForm.noteSection.placeholder")}
                          className="w-full px-3 py-2 border border-gray-300 dark:!border-[#3c3a3d] rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-200 dark:bg-[#141414] dark:text-gray-300"
                          value={data.digitalNotePlaceholder || ""}
                          onChange={(e) =>
                            setData({
                              ...data,
                              digitalNotePlaceholder: e.target.value,
                            })
                          }
                        />
                      </div>

                      <div className="flex items-center gap-2">
                        <Switch
                          size="small"
                          checked={data.digitalNoteRequired}
                          onChange={() =>
                            setData({
                              ...data,
                              digitalNoteRequired: !data.digitalNoteRequired,
                            })
                          }
                          className="bg-gray-300 dark:bg-[#3c3a3d]"
                        />
                        <span className="text-sm text-gray-600 dark:text-gray-400">
                          {t("digitalForm.noteSection.required")}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="bg-white dark:!bg-[#181819] rounded-xl shadow-sm p-6 border border-[#fbf4ff] dark:!border-[#3c3a3d] mb-6">
                    <div className="flex items-center mb-4">
                      <Type size={20} className="text-[#9e68ba] ml-2" />{" "}
                      <h3 className="text-lg font-semibold text-gray-800 dark:text-gray-200">
                        {t("digitalForm.privacyPolicySection.title")}
                      </h3>
                    </div>

                    <div className="border border-gray-200 dark:!border-[#3c3a3d] rounded-lg p-4">
                      <div className="flex items-center justify-between mb-3">
                        <div className="flex items-center gap-x-2">
                          <input
                            type="checkbox"
                            checked={data.privacyPolicyField}
                            onChange={handlePrivacyToggle}
                            className="h-4 w-4 text-purple-600 rounded border-gray-300 dark:!border-[#3c3a3d] focus:ring-purple-200"
                          />
                          <label className="ml-2 block text-sm font-medium text-gray-700 dark:text-gray-300">
                            {t("digitalForm.privacyPolicySection.label")}
                          </label>
                        </div>
                        <OverlayTrigger
                          placement="top"
                          overlay={
                            <Tooltip>
                              {t("digitalForm.privacyPolicySection.tooltip")}
                            </Tooltip>
                          }
                        >
                          <span>
                            <Info
                              size={16}
                              className="text-gray-400 dark:text-gray-400"
                            />
                          </span>
                        </OverlayTrigger>
                      </div>

                      <div className="mb-3">
                        <input
                          type="text"
                          placeholder={t(
                            "digitalForm.privacyPolicySection.placeholder"
                          )}
                          className="w-full px-3 py-2 border border-gray-300 dark:!border-[#3c3a3d] rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-200 dark:bg-[#141414] dark:text-gray-300"
                          value={data.privacyPolicyPlaceholder}
                          onChange={(e) =>
                            setData({
                              ...data,
                              privacyPolicyPlaceholder: e.target.value,
                            })
                          }
                          disabled={!data.privacyPolicyField}
                        />
                      </div>

                      <div className="flex items-center gap-2">
                        <Switch
                          size="small"
                          checked={data.privacyPolicyRequired}
                          onChange={handlePrivacyRequiredToggle}
                          disabled={!data.privacyPolicyField}
                          className="bg-gray-300 dark:bg-[#3c3a3d]"
                        />
                        <span className="text-sm text-gray-600 dark:text-gray-400">
                          {t("digitalForm.privacyPolicySection.required")}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="bg-white dark:!bg-[#181819] rounded-xl shadow-sm p-6 border border-[#fbf4ff] dark:!border-[#3c3a3d] mb-6">
                    <div className="flex items-center mb-4">
                      <ShoppingCart size={20} className="text-[#9e68ba] ml-2" />
                      <h3 className="text-lg font-semibold text-gray-800 dark:text-gray-200">
                        {t("digitalForm.productCardsSection.title")}
                      </h3>
                    </div>

                    <div className="border border-gray-200 dark:!border-[#3c3a3d] rounded-lg p-4">
                      <div className="mb-4">
                        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-3">
                          {t("digitalForm.productCardsSection.behaviorLabel")}
                        </label>

                        <div className="space-y-3">
                          {/* Option 1: Nouvelle page pour tout */}
                          <div className="flex items-center">
                            <input
                              type="radio"
                              id="newPage"
                              name="productClickBehavior"
                              value="newPage"
                              checked={data.productClickBehavior === "newPage"}
                              onChange={(e) =>
                                setData({
                                  ...data,
                                  productClickBehavior: e.target.value,
                                })
                              }
                              className="h-4 w-4 text-purple-600 border-gray-300 dark:!border-[#3c3a3d] focus:ring-purple-200"
                            />
                            <label
                              htmlFor="newPage"
                              className="ml-3 text-sm text-gray-700 dark:text-gray-300"
                            >
                              {t(
                                "digitalForm.productCardsSection.options.newPage"
                              )}
                            </label>
                          </div>

                          {/* Option 2: Modal pour tout */}
                          <div className="flex items-center">
                            <input
                              type="radio"
                              id="modal"
                              name="productClickBehavior"
                              value="modal"
                              checked={data.productClickBehavior === "modal"}
                              onChange={(e) =>
                                setData({
                                  ...data,
                                  productClickBehavior: e.target.value,
                                })
                              }
                              className="h-4 w-4 text-purple-600 border-gray-300 dark:!border-[#3c3a3d] focus:ring-purple-200"
                            />
                            <label
                              htmlFor="modal"
                              className="ml-3 text-sm text-gray-700 dark:text-gray-300"
                            >
                              {t(
                                "digitalForm.productCardsSection.options.modal"
                              )}
                            </label>
                          </div>

                          {/* Option 3: Comportement mixte - carte -> page, bouton -> modal */}
                          <div className="flex items-center">
                            <input
                              type="radio"
                              id="mixed1"
                              name="productClickBehavior"
                              value="mixed1"
                              checked={data.productClickBehavior === "mixed1"}
                              onChange={(e) =>
                                setData({
                                  ...data,
                                  productClickBehavior: e.target.value,
                                })
                              }
                              className="h-4 w-4 text-purple-600 border-gray-300 dark:!border-[#3c3a3d] focus:ring-purple-200"
                            />
                            <label
                              htmlFor="mixed1"
                              className="ml-3 text-sm text-gray-700 dark:text-gray-300"
                            >
                              {t(
                                "digitalForm.productCardsSection.options.mixed1"
                              )}
                            </label>
                          </div>

                          <div className="flex items-center">
                            <input
                              type="radio"
                              id="mixed2"
                              name="productClickBehavior"
                              value="mixed2"
                              checked={data.productClickBehavior === "mixed2"}
                              onChange={(e) =>
                                setData({
                                  ...data,
                                  productClickBehavior: e.target.value,
                                })
                              }
                              className="h-4 w-4 text-purple-600 border-gray-300 dark:!border-[#3c3a3d] focus:ring-purple-200"
                            />
                            <label
                              htmlFor="mixed2"
                              className="ml-3 text-sm text-gray-700 dark:text-gray-300"
                            >
                              {t(
                                "digitalForm.productCardsSection.options.mixed2"
                              )}
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="mt-4 p-3 bg-gray-50 dark:bg-[#141414] rounded-lg">
                        <div className="flex items-start gap-2">
                          <Info
                            size={16}
                            className="text-blue-500 mt-0.5 flex-shrink-0"
                          />
                          <div className="text-xs text-gray-600 dark:text-gray-400">
                            <p className="mb-1">
                              <strong>
                                {t(
                                  "digitalForm.productCardsSection.infoBox.newPageDesc"
                                )}
                              </strong>
                            </p>
                            <p className="mb-1">
                              <strong>
                                {t(
                                  "digitalForm.productCardsSection.infoBox.modalDesc"
                                )}
                              </strong>
                            </p>
                            <p>
                              <strong>
                                {t(
                                  "digitalForm.productCardsSection.infoBox.mixedDesc"
                                )}
                              </strong>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Preview Column */}
                <FormPreview data={data} store={digitalStore} />
              </div>
            )}
          </div>

          <Footer />
        </div>
      </div>
    </div>
  );
}

export default DigitalForm;
